import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["box"];

  connect() {
    this.previousFocus = document.activeElement;

    if (typeof this.element.showModal === "function") {
      this.element.showModal();
    }

    this.element.addEventListener("keydown", this.trapFocus);
    this.element.addEventListener("close", this.handleNativeClose);

    requestAnimationFrame(() => this.focusFirstElement());
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.trapFocus);
    this.element.removeEventListener("close", this.handleNativeClose);

    if (typeof this.element.close === "function" && this.element.open) {
      this.element.close();
    }

    this.restoreFocus();
  }

  close(event) {
    event?.preventDefault();

    if (typeof this.element.close === "function" && this.element.open) {
      this.element.close();
    } else {
      this.clearFrame();
    }
  }

  handleNativeClose = () => {
    this.clearFrame();
    this.restoreFocus();
  };

  clearFrame() {
    const frame = this.element.closest("turbo-frame#modal");
    if (frame) {
      frame.replaceChildren();
    } else {
      this.element.remove();
    }
  }

  restoreFocus() {
    if (
      this.previousFocus &&
      document.contains(this.previousFocus) &&
      typeof this.previousFocus.focus === "function"
    ) {
      this.previousFocus.focus();
    }
  }

  trapFocus = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      this.close(event);
      return;
    }

    if (event.key !== "Tab" || !this.hasBoxTarget) return;

    const focusable = this.boxTarget.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  focusFirstElement() {
    if (!this.hasBoxTarget) return;

    const focusable = this.boxTarget.querySelector(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    focusable?.focus();
  }
}
